import { Component, Input } from '@angular/core';
import { IBillingAccount } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-overview-header',
  templateUrl: './my-bill-overview-header.component.html',
  standalone: false,
})
export class MyBillOverviewHeaderComponent {
  @Input() mainTitle: string;
  @Input() subtitle?: string;
  @Input() shouldDisplayBackButton = true;
  @Input() shouldShowAccountSelection = false;
  @Input() shouldGoBackToOverview?: boolean;
  @Input() billingAccounts?: Array<IBillingAccount>;
  @Input() testId?: string;
}
